/* vDEV */
(() => {

  window.themeObj = {};
  
  window.themeObj.init = () => {
    const obj = window.themeObj;
    
    obj.snippets.init();
    obj.sections.init();
    obj.templates.init();
  };
  
  window.themeObj.tools = {
    
    cookie: {
      
      get: (name) => {
        const value = `; ${document.cookie}`;
  
        if (document.cookie.includes(`; ${name}=`)) {
          const parts = value.split(`; ${name}=`);
          
          if (parts.length === 2) {
            return parts.pop().split(';').shift();
          }
        }
  
        return '';
      },
      
      set: (name, value) => {
        var expires = "";
        
        var days = 365;
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        
        const cookieText = `${name}=${value}; expires=${date.toUTCString()}; domain=.${window.location.hostname}; path=/`;
        document.cookie = cookieText;
      }
    }
  }
  
  window.themeObj.templates = {
    init: () => {
      const obj2 = window.themeObj.templates;
  
      if (document.body.classList.contains('template-product')) {
        new obj2.product();
      
      } else if (document.body.classList.contains('template-collection')) {
        obj2.collection();
        
      } else if (document.body.classList.contains('template-page') && document.body.id == 'brands') {
        obj2.brands();
      }
    },
    product: class {
  
      constructor() {
        const obj2 = this;
        
        obj2.form();
        obj2.productPopups();
        obj2.desktopSlider();
        obj2.slider();
        obj2.productColors();
      }
  
      form() {
        const forms = document.querySelectorAll('.product-form__buttons--wrapper');
  
        if (!forms.length) {
          return;
        }

        forms.forEach((form) => {
          const formId = form.getAttribute('data-form-id');
          const formContent = document.getElementById(formId);

          if (formContent) {
            form.append(formContent);
          }
        });
      }
  
      productPopups() {
        const obj2 = this;

        class N8nForm extends HTMLElement {
  
          settings = {
            url: this.getAttribute('data-form-url'),
            type: this.getAttribute('data-form-type'),
            form: this.querySelector('form'),
            button: this.querySelector('button[data-n8n-form--action="submit"]')
          }
  
          constructor() {
            super();
            
            const obj3 = this;
            
            obj3.events();
            
            obj3.variantsField();
            obj3.storesField();
          }
  
          events() {
            const obj3 = this;
  
            obj3.settings.form.addEventListener('submit', (event) => {
              event.preventDefault();
              event.stopPropagation();
  
              obj3.form__submit();
              
              return false;
            });
  
            obj3.settings.button.addEventListener('click', () => {
              obj3.form__submit();
            });
          }
  
          /* Field: Variants */
          variantsField() {
            const obj3 = this;

            const productForm__wrapper = document.querySelector('.product-content');
  
            if (!productForm__wrapper) {
              return false;
            }
            
            const productVariants = productForm__wrapper.querySelectorAll('.product-form__fieldset input.radio-input[type="radio"][name="Shopify_option1"]');
            
            if (!productVariants.length) {
              return false;
            }
            
            productVariants.forEach((productVariant) => {
  
              productVariant.addEventListener('change', () => {
                const productVariant__sku = obj3.querySelector('[data-n8n-form--name="sku"]');
  
                if (productVariant__sku) {
                  productVariant__sku.value = productVariant.getAttribute('data-variant-sku');
                }
  
                const productVariant__quantity = obj3.querySelector('[data-n8n-form--name="product_variant_qty"]');
  
                if (productVariant__quantity) {
                  productVariant__quantity.value = parseInt(productVariant.getAttribute('data-variant-quantity'));
  
                  const modalOpener = document.querySelector(`.product-form__buttons--modals a.product-page_btn[href="#product-popup--${obj3.settings.type}"]`);
  
                  if (modalOpener) {
                    
                    if (productVariant__quantity.value > 0) {
                      modalOpener.removeAttribute('disabled');
                      
                    } else {
                      modalOpener.setAttribute('disabled', 'disabled');
                    }
                  }
                }
  
                const productVariant__id = obj3.querySelector('[data-n8n-form--name="product_variant_id"]');
  
                if (productVariant__id) {
                  productVariant__id.value = productForm__wrapper.querySelector('[name="id"]').value;
                }
  
                const productVariant__value = obj3.querySelector('[data-n8n-form--name="shopify_option1"]');
  
                if (productVariant__value) {
                  productVariant__value.value = productVariant.getAttribute('value');
                }
                
                const productVariant__imageUrl = obj3.querySelector('[data-n8n-form--name="image_url"]');
  
                if (productVariant__imageUrl) {
                  productVariant__imageUrl.value = productVariant.getAttribute('data-variant-image-url');
                }
              });
            });
          }
          /* /Field: Variants */
  
          /* Field: Stores */
          storesField() {
            const obj3 = this;
  
            document.addEventListener('theme:popup:opened', (event) => {
              const popup = event.detail.popup;
              const n8nForm = popup.querySelector('n8n-form');
  
              if (!n8nForm) {
                return false;
              }
              
              obj3.storesField__render();
            });

            if (window.location.hash == `#product-popup--${obj3.settings.type}`) {
              obj3.storesField__render();
            }
          }
          
          async storesField__render() {
            const obj3 = this;
            
            let items;
  
            const cookieItems = obj3.storesField__getCookieItems();
  
            if (cookieItems.length) {
              items = cookieItems;
            
            } else {
              items = await obj3.storesField__getRemoteItems();
  
              if (items && items.length) {
                await obj3.storesField__setCookieItems(items);
              }
            }
  
            await obj3.storesField__renderByItems(items);
          }
  
          async storesField__renderByItems(items) {
            const obj3 = this;
            
            if (!items || !items.length) {
              return false;
            }
  
            let formField__nativeSelect = obj3.settings.form.querySelector('select[data-n8n-form--name="store"]');
  
            if (!formField__nativeSelect || formField__nativeSelect.classList.contains('is-rendered')) {
              return false;
            }
  
            formField__nativeSelect.classList.add('is-rendered');
  
            /* Availability */
            const productTags = JSON.parse(document.getElementById('product-json-tags').innerText);
  
            const formField__availability__match = formField__nativeSelect.getAttribute('data-availability-match');
            const formField__availability__notMatch = formField__nativeSelect.getAttribute('data-availability--not-match');
  
            const formField__availableInStore = obj3.settings.form.querySelector('input[name="contact[available_in_store]"]');
            /* /Availability */
            
            let itemI = 0;
  
            items.forEach((item) => {
              let itemElement;
              
              let item__availableInStore = false;
              let item__availability = formField__availability__notMatch;
  
              if (productTags.includes(item.code)) {
                item__availableInStore = true;
                item__availability = formField__availability__match;
                
              }
              
              const itemText = `${item.shop} - ${item__availability}`;
  
              /* Native select item */
              itemElement = document.createElement('option');
              itemElement.setAttribute('value', item.code);
              itemElement.setAttribute('data--available-in-store', item__availableInStore);
              if(item__availableInStore){
                itemElement.style.color='#00822c'//green
              }else{
                itemElement.style.color='#969696'//gray
              }
              
              itemElement.innerHTML = itemText;
              formField__nativeSelect.append(itemElement);
              /* Native select item */
            });
  
            formField__nativeSelect.addEventListener('change', () => {
              const formField__nativeSelect__option = formField__nativeSelect.options[formField__nativeSelect.selectedIndex];
              formField__availableInStore.value = formField__nativeSelect__option.getAttribute('data--available-in-store');
            });
          }
          
          storesField__getCookieItems() {
            const obj3 = this;
            
            const cookieId = 'shopify--n8n:stores';
            
            const itemsText = window.themeObj.tools.cookie.get(cookieId);
            let newItems = [];
      
            if (itemsText) {
              const items = JSON.parse(itemsText);
              
              for (let itemKey in items) {
                newItems.push({
                  code: itemKey,
                  shop: items[itemKey]
                });
              }
            }
  
            return newItems;
          }
  
          async storesField__setCookieItems(items) {
            const obj3 = this;
  
            let newItems = {};
  
            items.forEach((item) => {
              newItems[item.code] = item.shop;
            });
            
            const cookieId = 'shopify--n8n:stores';
            window.themeObj.tools.cookie.set(cookieId, JSON.stringify(newItems));
          }
  
          async storesField__getRemoteItems() {
            const obj3 = this;
            
            const formUrl = 'https://n8n.eye-oo.com/webhook/odoo/stores/try/get';
  
            return await fetch(formUrl)
              .then((response) => {
  
                if (!response.ok) {
                  return false;
                }
                
                return response.json();
              })
                .then((response) => {
                  return response;
                });
          }
          /* /Field: Stores */
  
          /* Form: Submit */
          async form__submit() {
            const obj3 = this;
            
            obj3.settings.button.setAttribute('disabled', 'disabled');
  
            if (obj3.settings.form.checkValidity()) {
              await obj3.n8n__submit();
              
            } else {
              obj3.settings.form.reportValidity();
              obj3.settings.button.removeAttribute('disabled');
            }
          }
  
          async n8n__submit() {
            const obj3 = this;
            
            obj3.settings.button.setAttribute('disabled', 'disabled');
            
            const formFields = obj3.settings.form.querySelectorAll('[data-n8n-form--name]');
  
            if (!formFields.length) {
              return false;
            }
            
            const formBody = new FormData();
  
            formFields.forEach((formField) => {
              formField.setAttribute('value', formField.value);
  
              const formFieldNewName = formField.getAttribute('data-n8n-form--name');
              formBody.set(formFieldNewName, formField.value)
            });
  
            const formMethod = 'post';
  
            fetch(obj3.settings.url, {
              method: formMethod,
              body: formBody
            })
              .then((response) => {
              
                if (!response.ok) {
                  return false;
                }
  
                return response.json();
              })
              .then((response) => {
                
                if (!Array.isArray(response)) {
                  obj3.settings.button.removeAttribute('disabled');
    
                  return false;
                }
  
                return response;
              })
              .then((response) => {
                obj3.n8n__submitted(response);
              });
          }
  
          async n8n__submitted(items) {
            const obj3 = this;
  
            if (!items) {
              obj3.settings.button.removeAttribute('disabled');
              
              return false;
            }
  
            items.forEach((item) => {
              /* Alerts */
              const formAlerts = obj3.settings.form.querySelector('.n8n-form__alerts');
              formAlerts.innerHTML = '';
              
              if (item.message) {
                const itemElement = document.createElement('div');
                itemElement.classList.add('badge');
                
                if (item.status == 'OK') {
                  itemElement.classList.add('_success');
                  
                } else {
                  itemElement.classList.add('_error');
                }
                
                itemElement.innerHTML = item.message;
                
                formAlerts.append(itemElement);
                formAlerts.classList.remove('hide');
  
              } else {
                formAlerts.classList.add('hide');
              }
              /* /Alerts */
              
              /* Products */
              const formItems = obj3.querySelector('.n8n-form__products');
              formItems.innerHTML = '';
  
              if (item.status == 'KO' && item['products']) {
                
                item['products'].forEach((product) => {
                  const itemElement = document.createElement('div');
                  itemElement.innerHTML = `
                    <div class="n8n-form__product">
                      <div class="n8n-form__product-image">
                        <a href="${product.x_studio_url}">
                          <img
                            loading="lazy"
                            src="${product.x_studio_image_url}"
                            alt="${product.name}"
                          >
                        </a>
                      </div>
                      <div class="n8n-form__product-name">
                        <a href="${product.x_studio_url}">
                          ${product.name}
                        </a>
                      </div>
                    </div>
                  `;
                  formItems.append(itemElement);
                });
                
                formItems.classList.remove('hide');
              
              } else {
                formItems.classList.add('hide');
              }
              /* /Products */
  
              /* Fields */
              const formFields__wrapper = obj3.querySelector('.n8n-form__fields');
              formFields__wrapper.classList.add('hide');
              /* /Fields */
            });
          }
          /* /Form: Submit */
        }
  
        customElements.define('n8n-form', N8nForm);
      }
      
      slider() {
        const items = document.querySelector('.product-slider-main');
    
        if (items) {
          const dots = document.querySelector('.slider-thumbnails-wrapper');
        
          items.addEventListener('scroll', () => {
            const itemsWidth = items.clientWidth;
            const itemsScrollLeft = items.scrollLeft;
            
            const item = items.querySelector('.product-media__item');
            const itemWidth = item.offsetWidth;
            const itemI = Math.ceil(itemsScrollLeft / itemsWidth);
    
            const itemsX = 1;
            
            const dotPosition = Math.ceil(itemI / itemsX);
  
            const newDot = dots.querySelector(`[data-position="${dotPosition + 1}"]`);
    
            if (newDot) {
              dots.querySelector('.slider-active-class').classList.remove('slider-active-class');
              newDot.classList.add('slider-active-class');
            }
          });
        }
      }
  
      desktopSlider() {
        const buttons = document.querySelectorAll('.product-slider .slider-thumbnails-nav');
  
        if (buttons.length) {
  
          for (var i = 0; i < buttons.length; i++) {
            const button = buttons[i];
  
            button.addEventListener('click', () => {
              const buttonType = button.getAttribute('data-type');
              
              const items = document.querySelector('.slider-thumbnails-wrapper');
  
              const itemsWidth = items.clientWidth;
              const itemsScrollLeft = items.scrollLeft;
              
              const item = items.querySelector('.slider-thumbnails-slide');
              const itemWidth = item.offsetWidth;
              const itemI = Math.ceil(itemsScrollLeft / itemsWidth);
              
              const itemsX = 5;
  
              
              const activeItem = items.querySelector('.slider-thumb-active');
              const activeItemPosition = parseInt(activeItem.getAttribute('data-position'));
  
              var newActiveItemPosition;
  
              var newActiveItem;
  
              if (buttonType == 'next') {
                const originalButton = document.querySelector('.slider-button-next');
                originalButton.click();
                newActiveItemPosition = activeItemPosition + 1;
                
                newActiveItem = items.querySelector(`.slider-thumbnails-slide[data-position="${newActiveItemPosition}"]`);
  
              } else {
                const originalButton = document.querySelector('.slider-button-prev');
                originalButton.click();
                newActiveItemPosition = activeItemPosition - 1;
                
                newActiveItem = items.querySelector(`.slider-thumbnails-slide[data-position="${newActiveItemPosition}"]`);
              }
              
              newActiveItem = items.querySelector(`.slider-thumbnails-slide[data-position="${newActiveItemPosition}"]`);
              
              if (newActiveItem) {
                var newItemsScrollLeft;
                newItemsScrollLeft = (newActiveItemPosition - 3) * itemWidth;
  
                if (newItemsScrollLeft < 0) {
                  newItemsScrollLeft = 0;
                }
                
                const itemsScrollLeft = items.scrollLeft;
                items.scrollLeft = newItemsScrollLeft;
              }
            });
          }
        }
      }
  
      productColors() {

        class ProductFormColors extends HTMLElement {

          constructor() {
            super();
            
            const obj3 = this;
            
            obj3.render();
          }

          render() {
            const obj3 = this;
            
            const section = document.querySelector('.shopify-section--product-colors');
        
            if (!section) {
              return false;
            }

            const products = section.querySelector('.collection-grid');
            const url = section.querySelector('product-colors').getAttribute('data-url');
            
            fetch(url)
              .then(response => response.text())
              .then(response => {
                const fetchSection = new DOMParser()
                  .parseFromString(response, 'text/html')
                  .querySelector('.shopify-section--product-colors');
                
                const fetchProducts = fetchSection.querySelector('.collection-grid');
      
                if (!fetchProducts) {
                  return false;
                }
                
                const productId = section.querySelector('product-colors').getAttribute('data-product-id');
                const fetchSectionProduct = fetchSection.querySelector(`.product-card-minimal[data-product-id="${productId}"]`);
      
                if (fetchSectionProduct) {
                  fetchSectionProduct.remove();
                }
                
                if (fetchProducts.querySelectorAll('.product-card-minimal').length) {
                  products.innerHTML = fetchProducts.innerHTML;
                  section.classList.remove('hide');
    
                  const fetchProductColors = fetchSection.querySelector('product-form-colors');
                  const fetchProductColor = fetchProductColors.querySelector(`.radio-field--color[data-product-id="${productId}"]`);
        
                  if (fetchProductColor) {
                      fetchProductColor.classList.add('is-checked');
                  }
    
                  obj3.innerHTML = fetchProductColors.innerHTML;
                  obj3.classList.remove('hide');
                }
                
                document.dispatchEvent(new Event('theme:wishlist:render'));
              });
          }
        }

        customElements.define('product-form-colors', ProductFormColors);
      }
    },
    collection: () => {
      // const form = document.getElementById('facets-form');
  
      // if (!form) {
      //   return false;
      // }
  
      // form.addEventListener('change', () => {
      //   const filterLabels = form.querySelectorAll('details.disclosure-has-popup.facets__disclosure.opening');
  
      //   if (!filterLabels.length) {
      //     return false;
      //   }
  
      //   filterLabels.forEach((filterLabel) => {
  
      //     setTimeout(() => {
      //       filterLabel.classList.remove('opening');
      //       filterLabel.removeAttribute('open');
      //     }, 1000);
      //   });
      // });
    },
    brands: () => {
      const items = document.querySelectorAll('.MediaBrands__Letters a');
  
      if (items.length) {
  
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
  
          item.addEventListener('click', () => {
            document.body.classList.remove('header-visible');
            document.body.classList.add('header-folded');
  
            const header = document.querySelector('header-panel');
            header.classList.add('folded');
  
            setTimeout(() => {
              document.body.classList.remove('header-visible');
              document.body.classList.add('header-folded');
    
              const header = document.querySelector('header-panel');
              header.classList.add('folded');
            }, 100);
          });
        }
      }
    }
  };
  
  window.themeObj.sections = {
    
    init: () => {
      const obj2 = window.themeObj.sections;
      
      obj2.lazyLoad();
      obj2.header();
      
      new obj2.wishlist();
      new obj2.cart();
      new obj2.products();
      
      setInterval(function() {
        obj2.notifications();
      }, 500);
    },

    lazyLoad: () => {
      const obj2 = window.themeObj.sections;
  
      obj2.lazyLoad__event();
  
      window.addEventListener('scroll', () => {
        obj2.lazyLoad__event();
      });
  
      window.addEventListener('resize', () => {
        obj2.lazyLoad__event();
      });
    },
  
    lazyLoad__event: () => {
      const obj2 = window.themeObj.sections;
      
      const items = document.querySelectorAll('.is-lazyload:not(.is-lazyloaded)');
  
      if (!items.length) {
        return false;
      }
  
      const scrollTop = document.querySelector('html').scrollTop;
      const windowHeight = window.innerHeight;
  
      items.forEach((item) => {
        const itemReact = item.getBoundingClientRect();
  
        if (scrollTop + windowHeight >= itemReact.top) {
          item.classList.add('is-lazyloaded');
  
          const itemVideo = item.querySelector('video');
  
          if (itemVideo) {
            itemVideo.play();
          }
        }
      });
    },
    
    header: () => {
      const overlays = document.querySelectorAll('.list-menu-panel__overlay');
  
      if (overlays.length) {
  
        for (let i = 0; i < overlays.length; i++) {
          const overlay = overlays[i];
          
          overlay.addEventListener('mouseover', () => {
            const activeItem = document.querySelector('.list-menu-panels.open');
    
            if (activeItem) {
              activeItem.classList.remove('open');
            }
          });
        }
      }
    },
    notifications: () => {
      const items = document.querySelectorAll('.notifications-plugin-wrapper .notification__item_wrapper');
  
      var itemTexts = [];
  
      if (items.length) {
  
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
          const itemText = item.querySelector('.notification__html').innerHTML.trim();
  
          if (itemTexts.includes(itemText)) {
            item.remove();
            
          } else {
            itemTexts.push(itemText);
          }
        }
      }
    },
    wishlist: class {
  
      data = {
        host: 'shopify.eye-oo.com',
        cookieId: 'shopify--wishlist:products'
      }
      
      constructor() {
        const obj = this;
  
        obj.tools = window.themeObj.tools;
        
        if(document.getElementById('customerWishlistForm')) {
          obj.customerInit();
          
        } else {
          obj.guestInit();
        }
      }
  
      guestInit() {
        const obj = this;
        
        obj.renderItems();
        obj.renderLandingPage();
      }
      
      customerInit() {
        const obj = this;
        
        const form = document.getElementById('customerWishlistForm');
  
        if (form) {
          const formUrl = `https://${obj.data.host}/cart-wishlist/ajax:wishlist/get.json?shop=${Shopify.shop}`;
          const formMethod = 'POST';
          const formBody = new FormData(form);
    
          fetch(formUrl, {
            method: formMethod,
            body: formBody
          })
          .then(response => response.json())
          .then((response) => {
  
            if (response.status == 'success') {
              const items = response.response.products;
              const itemsText = JSON.stringify(items);
              
              obj.tools.cookie.set(obj.data.cookieId, itemsText);
            }
            
            obj.renderItems();
            obj.renderLandingPage();
          });
        }
      }
  
      updateCustomerItems() {
        const obj = this;
  
        const form = document.getElementById('customerWishlistForm');
  
        if (form) {
          const items = obj.getItems();
          
          const formProducts = form.querySelector('input[name="products"]');
          formProducts.value = JSON.stringify(items);
  
          const formUrl = `https://${obj.data.host}/cart-wishlist/ajax:wishlist/update.json?shop=${Shopify.shop}`;
          const formMethod = 'post';
          const formBody = new FormData(form);
    
          fetch(formUrl, {
            method: formMethod,
            body: formBody
          })
          .then(response => response.json())
          .then(function (response) {
            obj.renderItems();
            obj.renderLandingPage();
          });
        }
      }
  
      /* Actions */
      getItems() {
        const obj = this;
        
        const itemsText = obj.tools.cookie.get(obj.data.cookieId);
        let items = [];
  
        if (itemsText) {
          items = JSON.parse(itemsText);
        }
        
        return items;
      }
      
      checkItem(id, handle) {
        const obj = this;
  
        const items = obj.getItems();
        
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
  
          if (item.id == id && item.handle == handle) {
            return true;
          }
        }
        
        return false;
      }
  
      addItem(id, handle) {
        const obj = this;
  
        if (!obj.checkItem(id, handle)) {
          const items = obj.getItems();
          
          let newItems = items;
          let newItemsFound = false;
        
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
    
            if (item.id == id && item.handle == handle) {
              newItemsFound = true;
            }
          }
  
          if (!newItemsFound) {
            newItems.unshift({
              id: parseInt(id),
              handle: handle
            });
          }
          
          const newItemsText = JSON.stringify(newItems);
          obj.tools.cookie.set(obj.data.cookieId, newItemsText);
          
          obj.updateCustomerItems();
        }
      }
      
      removeItem(id, handle) {
        const obj = this;
  
        let items = obj.getItems();
  
        if (obj.checkItem(id, handle)) {
    
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
    
            if (item.id == id && item.handle == handle) {
              items.splice(i, 1);
            }
          }
    
          const itemsText = JSON.stringify(items);
          obj.tools.cookie.set(obj.data.cookieId, itemsText);
          
          obj.updateCustomerItems();
        }
      }
      /* /Actions */
  
      renderItems() {
        const obj = this;
        
        const eventName = 'theme:wishlist:render';
        const event = new Event(eventName);
  
        document.addEventListener(eventName, () => {
          const items = document.querySelectorAll('*[data-wishlist-handle]:not([data-wishlist-rendered])');
  
          if (items) {
      
            for (let i = 0; i < items.length; i++) {
              const item = items[i];
              item.setAttribute('data-wishlist-rendered', true);
              
              const itemId = item.getAttribute('data-wishlist-id');
              const itemHandle = item.getAttribute('data-wishlist-handle');
              
              if (obj.checkItem(itemId, itemHandle)) {
                item.setAttribute('data-wishlist-active', true);
              }
      
              item.addEventListener('click', () => {
                const itemId = item.getAttribute('data-wishlist-id');
                const itemHandle = item.getAttribute('data-wishlist-handle');
    
                if (item.hasAttribute('data-wishlist-active')) {
                  item.removeAttribute('data-wishlist-active');
                  obj.removeItem(parseInt(itemId), itemHandle);
                  
                } else {
                  item.setAttribute('data-wishlist-active', true);
                  obj.addItem(parseInt(itemId), itemHandle);
                }
              });
            }
          }
        });
        
        document.dispatchEvent(event);
      }
  
      /* Landing page */
      renderLandingPage() {
        const obj = this;
        
        const section = document.querySelector('.wishlist-page');
        
        if (section) {
          const items = obj.getItems();
    
          if (items.length) {
            
            for (let i = 0; i < items.length; i++) {
              const item = items[i];
              
              obj.renderLandingPageItem(item.id, item.handle);
            }
          }
        }
      }
      
      renderLandingPageItem(id, handle) {
        const obj = this;
        
        const section = document.querySelector('.wishlist-page');
        
        const formUrl = `/products/${handle}?section_id=product-wishlist-card`;
  
        fetch(formUrl)
          .then(response => response.text())
          .then(response => {
            const fetchContent = new DOMParser()
              .parseFromString(response, 'text/html')
              .querySelector('.shopify-section table tr');
  
            if (fetchContent) {
              const removeButton = fetchContent.querySelector('.cart-remove');
    
              removeButton.addEventListener('click', () => {
                fetchContent.remove();
    
                obj.removeItem(id, handle);
              });
    
              const wrapper = section.querySelector('#main-wishlist-items');
              wrapper.append(fetchContent);
            }
          });
      }
      /* /Landing page */
    },
    cart: class {
  
      data = {
        host: 'shopify.eye-oo.com'
      }
      
      constructor() {
        const obj = this;
  
        if(document.getElementById('customerCartForm')) {
          obj.customerInit();
        }
      }
  
      customerInit() {
        const obj = this;
  
        obj.loadCustomerItems();
  
        document.addEventListener('cart:updated', (event) => {
          const items = event.detail.cart.items;
          obj.updateCustomerItems(items);
        });
      }
  
      loadCustomerItems() {
        const obj = this;
  
        const form = document.getElementById('customerCartForm');
  
        if (form) {
          const formUrl = `https://${obj.data.host}/cart-wishlist/ajax:cart/get.json?shop=${Shopify.shop}`;
          const formMethod = 'post';
          const formBody = new FormData(form);
    
          fetch(formUrl, {
            method: formMethod,
            body: formBody
          })
          .then(response => response.json())
          .then((response) => {
  
            if (response.status == 'success') {
              const items = response.response.items ? response.response.items : [];
              obj.updateGuestItems(items); 
            }
          });
        }
      }
  
      updateCustomerItems(items) {
        const obj = this;
  
        const form = document.getElementById('customerCartForm');
  
        if (form) {
          let newItems = [];
    
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
    
            newItems.push({
              variant_id: parseInt(item.variant_id),
              quantity: parseInt(item.quantity)
            });
          }
  
          const formItems = form.querySelector('input[name="items"]');
          formItems.value = JSON.stringify(newItems);
  
          const formUrl = `https://${obj.data.host}/cart-wishlist/ajax:cart/update.json?shop=${Shopify.shop}`;
          const formMethod = 'post';
          const formBody = new FormData(form);
    
          fetch(formUrl, {
            method: formMethod,
            body: formBody
          })
          .then(response => response.json());
        }
      }
  
      updateGuestItems(items) {
        const obj = this;
  
        let updates = {};
  
        if (items.length) {
          
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
  
            if (item.variant_id && item.quantity > 0) {
              updates[item.variant_id] = item.quantity;
            }
          }
        }
         
        window.QQ.updateCart(updates);
      }
    },
    products: class {
  
      constructor() {
        const obj = this;
        
        obj.renderItems();
      }
      
      renderItems() {
        const obj = this;
        
        const eventName = 'theme:products:render';
        const event = new Event(eventName);
  
        document.addEventListener(eventName, () => {
          const items = document.querySelectorAll('.collection-grid .product-card-minimal');
    
          if (items.length) {
            
            for (let i = 0; i < items.length; i++) {
              const item = items[i];
              obj.renderItem(item, i);
            }
          }
        });
        
        document.dispatchEvent(event);
      }
  
      renderItem(item, i) {
        const obj = this;
        
        obj.renderItemColors(item, i);
      }
  
      renderItemColors(item, i) {
        const obj = this;
  
        const itemColors = item.querySelector('.collection-grid__colors[data-tag]');
  
        if (itemColors) {
  
          setTimeout(() => {
            const itemColorsTag = itemColors.getAttribute('data-tag');
  
            const items2Colors = document.querySelectorAll(`.collection-grid .product-card-minimal .collection-grid__colors[data-tag="${itemColorsTag}"]`);
      
            if (items2Colors.length) {
      
              for (let i2 = 0; i2 < items2Colors.length; i2++) {
                const item2Colors = items2Colors[i2];
                const url = `/search?type=product&view=json&q=${encodeURIComponent(itemColorsTag)}`;
                
                fetch(url, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  }
                }).then((response) => response.json())
                  .then((response) => {
                    item2Colors.removeAttribute('data-tag');
                    
                    const item2ColorsCount = parseInt(response.results_count);
      
                    if (item2ColorsCount == 1) {
                      const item2ColorsText = item2Colors.getAttribute('data-text-color').replace(/\%count\%/, item2ColorsCount);
                      item2Colors.innerHTML = item2ColorsText;
                      
                    } else if (item2ColorsCount > 1) {
                      const item2ColorsText = item2Colors.getAttribute('data-text-colors').replace(/\%count\%/, item2ColorsCount);
                      item2Colors.innerHTML = item2ColorsText;
                    
                    } else {
                      item2Colors.remove();
                    }
                });
              }
            }
            
          }, (100 * i));
        }
      }
    }
  };
  
  window.themeObj.snippets = {
    init: () => {
      const obj2 = window.themeObj.snippets;
  
      obj2.lazyLoad__event();
  
      window.addEventListener('scroll', () => {
        obj2.lazyLoad__event();
      });
  
      window.addEventListener('resize', () => {
        obj2.lazyLoad__event();
      });
    },

    lazyLoad__event: () => {
      const obj2 = window.themeObj.snippets;
      
      const items = document.querySelectorAll('.is-lazyload:not(.is-lazyloaded)');
  
      if (!items.length) {
        return false;
      }
  
      const scrollTop = document.querySelector('html').scrollTop;
      const windowHeight = window.innerHeight;
  
      items.forEach((item) => {
        const itemReact = item.getBoundingClientRect();
  
        if (scrollTop + windowHeight >= itemReact.top) {
          item.classList.add('is-lazyloaded');
  
          const itemVideo = item.querySelector('video');
  
          if (itemVideo) {
            itemVideo.play();
          }
        }
      });
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    window.themeObj.init();
  });
  
})();
/* /vDEV */